module.exports = __webpack_public_path__ + "img/web-Icon.668286a9.svg";